/**
 * Barra superior no computador (sketch 010, SHELL-05): busca com Ctrl K (abre a paleta),
 * microfone «Ditar documento» e «Novo documento». No celular nada disso aparece: a Hoje e a
 * aba Documentos já levam ao mesmo lugar.
 */
import { useGuardedNavigate } from '@/shared/lib/useGuardedNavigate'
import { MicIcon, PlusIcon, SearchIcon } from '@/shared/ui/icons'
import { Tooltip } from '@/shared/ui/Tooltip'
import { NEW_PRESCRIPTION_STATE } from '@/widgets/navigation/newPrescriptionState'

export const DesktopTopBarSearch = ({ onOpenGoTo }: { onOpenGoTo: () => void }) => (
  <button
    type="button"
    onClick={onOpenGoTo}
    aria-label="Buscar paciente ou página"
    aria-keyshortcuts="Control+K"
    className="hidden h-8 w-full max-w-md items-center gap-2 rounded-full bg-[var(--color-chrome-control-bg)] px-3 text-sm text-[var(--color-chrome-ink-subtle)] transition-colors hover:bg-[var(--color-chrome-hover)] md:flex"
  >
    <SearchIcon size={16} aria-hidden className="shrink-0" />
    <span className="min-w-0 flex-1 truncate text-left">Buscar paciente ou página</span>
    <kbd className="rounded-md bg-[var(--color-chrome-control-bg)] px-1.5 py-0.5 font-mono text-[10px] font-bold text-[var(--color-chrome-foreground)]">
      Ctrl K
    </kbd>
  </button>
)

export const DesktopTopBarDictate = () => {
  const navigate = useGuardedNavigate()
  return (
    <Tooltip label="Ditar documento">
      <button
        type="button"
        onClick={() => void navigate('/documentos', { state: NEW_PRESCRIPTION_STATE })}
        aria-label="Ditar documento"
        className="hidden h-11 w-11 items-center justify-center rounded-lg text-[var(--color-chrome-foreground)] transition-colors hover:bg-[var(--color-chrome-hover)] md:inline-flex"
      >
        <MicIcon size={20} aria-hidden />
      </button>
    </Tooltip>
  )
}

export const DesktopTopBarNewDocument = () => {
  const navigate = useGuardedNavigate()
  return (
    <button
      type="button"
      onClick={() => void navigate('/documentos', { state: NEW_PRESCRIPTION_STATE })}
      className="ml-1 hidden h-8 items-center gap-1.5 rounded-full border border-[var(--color-mint-strong)] bg-[var(--color-mint-soft)] px-3 text-sm font-semibold text-[var(--color-teal-ink)] transition-colors hover:bg-[var(--color-mint-soft)]/80 md:inline-flex"
    >
      <PlusIcon size={16} aria-hidden />
      Novo documento
    </button>
  )
}
